module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("实时收款")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "trade-table",
    attrs: {
      "data": _vm.trades,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "店铺名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.shop.shopname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "busicd",
      "label": "交易类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("busicdText")(scope.row.busicd)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "min-width": "150",
      "label": "交易时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.sysdtm))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', {
          staticClass: "font-large"
        }, [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.orig_amt || scope.row.txamt)) + "元")]), _vm._v(" "), (scope.row.busicd.substring(0, 4) === '7000') ? _c('p', {
          staticClass: "font-small"
        }, [_vm._v("实收0元")]) : _c('p', {
          staticClass: "font-small"
        }, [_vm._v("实收" + _vm._s(_vm._f("formatCurrency")(scope.row.txamt)) + "元")]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.merchanCouponAmt),
            expression: "scope.row.merchanCouponAmt"
          }],
          staticClass: "font-small"
        }, [_vm._v("商家红包" + _vm._s(_vm._f("formatCurrency")(scope.row.merchanCouponAmt)) + "元")]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (parseInt(scope.row.coupon_amt)),
            expression: "parseInt(scope.row.coupon_amt)"
          }],
          staticClass: "font-small"
        }, [_vm._v("平台补贴" + _vm._s(_vm._f("formatCurrency")(scope.row.coupon_amt)) + "元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cancel",
      "label": "交易状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("tradeStatus")(scope.row.cancel)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "syssn",
      "min-width": "210",
      "label": "流水号"
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "view-more"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.toLink
    }
  }, [_vm._v("查看更多 >>")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("流水列表")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v("每5s自动刷新")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-87020b96"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/todaytrade/todaytrade.vue
// module id = 841
// module chunks = 0